module.exports = __webpack_public_path__ + "img/staff-1988-heilongtan.8dc6bc70.jpg";